import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-color-intersect-large.tsx
/**
* icon.24.color.intersect.large
*
* Keywords: overlap, subtract, difference, exclusion, xor, cut, remove, geometry
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE0IDhhNiA2IDAgMCAxIDEuNzQyLjI1NyA2IDYgMCAwIDEtNy40ODUgNy40ODVBNiA2IDAgMCAxIDE0IDgiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTAgM2E3IDcgMCAwIDEgNi41MjcgNC40NzJBNy4wMDEgNy4wMDEgMCAwIDEgMTQgMjFhNyA3IDAgMCAxLTYuNTI4LTQuNDczQTcgNyAwIDAgMSAxMCAzbTYuODg0IDUuNzM3cS4xMTQuNjE2LjExNiAxLjI2M2E3IDcgMCAwIDEtOC4yNjMgNi44ODQgNiA2IDAgMSAwIDguMTQ3LTguMTQ3TTE0IDhhNiA2IDAgMCAwLTUuNzQzIDcuNzQyIDYgNiAwIDAgMCA3LjQ4NS03LjQ4NUE2IDYgMCAwIDAgMTQgOG0tNC00YTYgNiAwIDAgMC0yLjg4NSAxMS4yNjIgNyA3IDAgMCAxIDguMTQ2LTguMTQ2QTYgNiAwIDAgMCAxMCA0Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=24953-61191
*/
const Icon24ColorIntersectLarge = memo(function Icon24ColorIntersectLarge(props) {
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [/* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color-3, var(--color-icon-tertiary))",
			d: "M14 8a6 6 0 0 1 1.742.257 6 6 0 0 1-7.485 7.485A6 6 0 0 1 14 8"
		}), /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10 3a7 7 0 0 1 6.527 4.472A7.001 7.001 0 0 1 14 21a7 7 0 0 1-6.528-4.473A7 7 0 0 1 10 3m6.884 5.737q.114.616.116 1.263a7 7 0 0 1-8.263 6.884 6 6 0 1 0 8.147-8.147M14 8a6 6 0 0 0-5.743 7.742 6 6 0 0 0 7.485-7.485A6 6 0 0 0 14 8m-4-4a6 6 0 0 0-2.885 11.262 7 7 0 0 1 8.146-8.146A6 6 0 0 0 10 4"
		})]
	});
});
//#endregion
export { Icon24ColorIntersectLarge };

//# sourceMappingURL=icon-24-color-intersect-large.js.map